import { render, staticRenderFns } from "./juryEdit.vue?vue&type=template&id=08090152"
import script from "./juryEdit.vue?vue&type=script&lang=js"
export * from "./juryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08090152')) {
      api.createRecord('08090152', component.options)
    } else {
      api.reload('08090152', component.options)
    }
    module.hot.accept("./juryEdit.vue?vue&type=template&id=08090152", function () {
      api.rerender('08090152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/jury/juryEdit.vue"
export default component.exports